import React, { useState, useEffect } from 'react';
import './BrandedLoader.css';

const BrandedLoader = () => {
  const logos = [
    '/assets/images/suppliers/ZotraiLogo.png', 
    '/assets/images/suppliers/tripjack.png',
    '/assets/images/suppliers/Riya.png',
    '/assets/images/suppliers/tbo.png',
    '/assets/images/suppliers/airiq.png',
    '/assets/images/suppliers/booking.png',
    '/assets/images/suppliers/viator.png',
    '/assets/images/suppliers/grn.png',
    '/assets/images/suppliers/ratehawk.png',
    '/assets/images/suppliers/rezlive.png',
  ];

  // ... rest of the component is the same
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentLogoIndex(prevIndex => (prevIndex + 1) % logos.length);
    }, 2000);

    return () => clearInterval(intervalId);
  }, [logos.length]);

  return (
    <div className="branded-loader-container">
      <img
        key={currentLogoIndex}
        src={logos[currentLogoIndex]}
        alt="Loading..."
        className="branded-loader-image"
      />
      <p className="branded-loading-text">Loading, Please wait...</p>
    </div>
  );
};
 
export default BrandedLoader;